import { render } from "./Admin-form.vue?vue&type=template&id=5f82a82e&scoped=true"
import script from "./Admin-form.vue?vue&type=script&lang=js"
export * from "./Admin-form.vue?vue&type=script&lang=js"

import "./Admin-form.vue?vue&type=style&index=0&id=5f82a82e&scoped=true&lang=css"

import exportComponent from "/root/fixed-links/crm-updated/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f82a82e"]])

export default __exports__